<script>
  import { _ } from 'svelte-i18n';
  import { Button, Indicator } from 'flowbite-svelte';
  import { FileExportSolid } from 'flowbite-svelte-icons';
  import Heading from './Heading.svelte';
  import PercentChange from './PercentChange.svelte';

  export let key;
  export let legend; // FIXME: reconsider this prop name (redundant to component name)
  export let indicatorColors;
  export let onClickExport;
</script>

<ul class="flex flex-col">
  {#each legend as item, index}
    <li class="flex items-center justify-between border-b py-2">
      <span class="flex items-center text-gray-900"
        ><Indicator
          size="sm"
          class={`me-1.5 ${
            indicatorColors[
              index >= indicatorColors.length
                ? index % indicatorColors.length
                : index
            ]
          }`}
        />{item[key]}</span
      >
      <div class="flex flex-col text-right text-gray-500">
        <Heading>{item.percentage}</Heading>
        <div class="text-xs">
          <PercentChange
            current={item.currentJourneys}
            previous={item.previousJourneys}
            >{$_('_shared.legend.vsPreviousPeriod', {
              default: 'vs. previous period',
            })}</PercentChange
          >
        </div>
      </div>
    </li>
  {/each}
</ul>
{#if onClickExport}
  <div class="mt-4 flex flex-1 items-end">
    <Button on:click={onClickExport} size="sm" color="light" class="w-fit"
      ><FileExportSolid class="me-2 h-3.5 w-3.5" />{$_(
        '_shared.legend.export',
        {
          default: 'Export',
        },
      )}</Button
    >
  </div>
{/if}
